// extracted by mini-css-extract-plugin
export default {"wrapper":"Anchors_wrapper__fk89m","title":"Anchors_title__vkr0q","list":"Anchors_list__MWOVy"};